import React from "react";
import { MdSearch, MdRefresh, MdAdd } from "react-icons/md";

const ActionBar = ({ searchTerm, onSearchChange, onRefresh, onCreateNew, loading }) => {
  return (
    <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
      <div className="relative min-w-[200px] max-w-xs flex-1">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <MdSearch className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="search"
          className="w-full rounded-md border border-gray-300 px-3 py-2 pl-10 focus:border-[#57A863] focus:outline-none focus:ring-[#57A863]"
          placeholder="Rechercher une promotion..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <div className="flex gap-3">
        <button
          onClick={onRefresh}
          className="flex items-center justify-center rounded-md bg-white p-2 text-gray-700 transition-all hover:bg-gray-100 border border-gray-300 shadow-sm"
          title="Rafraîchir"
          disabled={loading}
        >
          <MdRefresh className={`h-5 w-5 ${loading ? "animate-spin" : ""}`} />
        </button>

        <button
          onClick={onCreateNew}
          className="flex items-center gap-2 rounded-md bg-[#57A863] px-4 py-2 text-white transition-all hover:bg-[#4c9657] shadow-sm"
          disabled={loading}
        >
          <MdAdd className="h-5 w-5" />
          <span>Nouvelle Promotion</span>
        </button>
      </div>
    </div>
  );
};

export default ActionBar;